const state = {
  items: [],
}

const getters = {
  count: state => {
    return state.items.length;
  },
  getById: (state) => (id) => {
    return state.items.find(item => item.id == id);
  },
  getAll: (state) => {
    return state.items;
  },
  getByMatchId: (state) => (id_partido) => {
    return state.items.find(item => item.id_partido == id_partido);
  }
}

const actions = {

  retrieveFromLS ({ commit }) {
    let items = JSON.parse(localStorage.getItem('db.planillas'));

    items = items ? items.filter(item => item.id_partido) : [];

    if (items) commit('setItems', items);
  },

  setAndPersistLS({ dispatch, commit }, items) {
    commit('setItems', items);
    dispatch('persistLS');
  },

  persistLS({ state }) {
    localStorage.setItem('db.planillas', JSON.stringify(state.items));
  },

  removeByMatchId({ state, commit, dispatch }, id) {
    let index = state.items.findIndex(item => item.id_partido == id);
    commit('removeItemByIndex', index);
    dispatch('persistLS');
  },

  updateOrInsert({ state, commit, dispatch }, item) {
    let index = state.items.findIndex(itemObj => itemObj.id_partido == item.id_partido);
    if (index == -1) {
      commit('insert', item);
    } else {
      commit('update', {index: index, item: item});
    }
    dispatch('persistLS');
  }
}

const mutations = {

  setItems (state, items) {
    state.items = items
  },

  removeItemByIndex (state, index) {
    state.items.splice(index, 1);
  },

  insert (state, item) {
    state.items.push(item);
  },

  update (state, payload) {
    state.items[payload.index] = payload.item;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}